import { Policy, PolicyStatus } from "@/types";

/**
 * Returns the most relevant policy:
 * - Prefers one with PolicyStatus.ACTIVE status
 * - Falls back to first policy in the list
 */
export const getRelevantPolicy = (policies: Policy[] = []): Policy | undefined => {
  // Return first active policy
  const activePolicy = policies.find((p) => p.status === PolicyStatus.ACTIVE);

  if (activePolicy) {
    return activePolicy;
  }

  // Fallback to first available policy
  return policies[0];
};
